<template>
  <van-popup
    v-model:show="isShow"
    position="bottom"
    class="report-popup"
    teleport="body"
  >
    <p>Report Reason</p>
    <ul>
      <li
        v-for="item in list"
        :key="item.value"
        class="flex v-c"
        @click="active = item.value"
      >
        <div class="sel" :class="{ seled: active == item.value }"></div>
        <div class="msg">{{ $t(item.label) }}</div>
      </li>
      <!-- <li class="flex v-c">
        <div class="sel"></div>
        <div class="msg">Other</div>
      </li> -->
    </ul>
    <!-- <div class="block flex center">
      <div class="sel"></div>
      <div class="msg">Blacklisted</div>
    </div> -->
    <van-button class="btn" @click="handleReport">
      {{ $t('report.Confirm') }}
    </van-button>
  </van-popup>
</template>

<!-- 举报弹窗
  @expose {function(id:number)} open 打开弹窗

  示例：
  const reportRef = ref<InstanceType<typeof Report> | null>(null)
  
  <Report ref="reportRef" />

  reportRef.value?.open(uid)

-->
<script setup lang="ts">
import { apiReport } from '@/api/user'

const i18n = useNuxtApp().$i18n

// 监听路由，切换页面关闭弹窗
const router = useRouter()
router.afterEach(() => {
  isShow.value = false
})

// 举报
async function handleReport() {
  isShow.value = false
  const res = await apiReport({
    reportType: active.value,
    type: active.value,
    reportUid: reportUid.value as number
  })
  const { code } = res
  if (code === 200) {
    showToast(i18n.t('report.ReportS'))
  }
}

// 列表
const list = ref([
  {
    label: 'report.PS',
    value: 1
  },
  {
    label: 'report.PAV',
    value: 2
  },
  {
    label: 'report.AH',
    value: 3
  },
  {
    label: 'report.PA',
    value: 4
  }
])
const active = ref<number>(1)

const reportUid = ref<number>()
const isShow = ref<boolean>(false)
function open(id: number) {
  reportUid.value = id
  isShow.value = true
}
defineExpose({ open })
</script>

<style lang="scss" scoped>
@import './scss/index.scss';
</style>
